import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import BrandMark from "./BrandMark";

const ARTICLES = [
  { title: "Why We're Building Real-Time AI Video Companions", slug: "why-were-building-real-time-ai-video-companions", excerpt: "The thinking behind moving AI companionship from text boxes to live, face-to-face interaction." },
  { title: "Inside Our Real-Time AI Videochat MVP", slug: "inside-our-real-time-ai-videochat-mvp", excerpt: "What the first product milestone includes, and how we are approaching the build." },
  { title: "Why Photorealistic AI Avatars Matter", slug: "why-photorealistic-ai-avatars-matter", excerpt: "Presence, expression and realism — why believable characters change the experience." },
  { title: "From Digital AI Characters to Humanoid AI", slug: "from-digital-ai-characters-to-humanoid-ai", excerpt: "Our long-term vision for taking the same intelligence beyond the screen." },
  { title: "Our Roadmap to Interactive AI Entertainment", slug: "our-roadmap-to-interactive-ai-entertainment", excerpt: "The four chapters ahead: avatars, MVP, commercial platform and humanoid AI." },
  { title: "Preparing AIROBOTCAMSTUDIO for Investment", slug: "preparing-airobotcamstudio-for-investment", excerpt: "How we are preparing our £150,000 fundraising round and what it will accelerate." },
  { title: "Understanding Our SEIS Advance Assurance Preparation", slug: "understanding-our-seis-advance-assurance-preparation", excerpt: "What SEIS Advance Assurance is, and where our application currently stands." },
];

export default function Updates() {
  return (
    <section id="updates" data-testid="updates-section" className="relative bg-[#0a0a0a] py-16 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <div className="flex items-center gap-4">
            <BrandMark className="h-10 w-10 rounded-lg" testid="updates-logo" />
            <SectionTag>Updates</SectionTag>
          </div>
          <h2 className="font-display mt-5 text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
            Company <span className="text-cyan-300">Updates</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#C5CBD5]">
            Notes from the team as we build — what we are doing, why we are doing it, and exactly
            where things stand.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {ARTICLES.map(({ title, slug, excerpt }, i) => (
            <Reveal key={title} delay={0.05 * (i % 3)} className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <a
                href={`/updates/${slug}`}
                data-testid={`update-card-${i}`}
                className="group flex h-full cursor-pointer flex-col justify-between rounded-2xl border border-white/10 bg-black/40 p-7 transition-colors duration-500 hover:border-cyan-300/30"
              >
                <div>
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-cyan-300/70">Journal</span>
                    <ArrowUpRight size={16} className="text-white/25 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-cyan-300" />
                  </div>
                  <h3 className="font-display mt-5 text-lg font-medium leading-snug tracking-tight text-white">
                    {title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/50">{excerpt}</p>
                </div>
                <span
                  data-testid={`read-article-cta-${i}`}
                  className="mt-7 inline-flex w-fit cursor-pointer items-center gap-2 rounded-md bg-cyan-300 px-5 py-2.5 text-[13px] font-bold text-black transition-all duration-300 hover:bg-cyan-200 active:scale-[0.98] group-hover:-translate-y-0.5"
                >
                  Read Full Article
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
